<template>
    <div>
      <div v-if="productDescription || sampleContent">
        Description provided
      </div>
      <div v-else style="color: var(--v-darkGrayColor-base); font-weight: normal;">
        No description provided
      </div>
    </div>
</template>

<script>
import {
  STEPS,
} from "@/components/FullPageSourceEditorV2/components/AiWriter/constants.js";

export default {
    name: 'ConfigPreviewProductDescription',
    props: [
        'productDescription',
        'sampleContent',
    ],
    computed: {
        STEPS() {
          return STEPS
        },
    }
}
</script>

<style lang="scss" scoped>

</style>